import { IonContent, IonPage } from '@ionic/react';
import { useLocalStorage } from 'beautiful-react-hooks';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import Pill from '../components/c-pill';

export default function TriggerRecorder() {
	const [session, setSession] = useLocalStorage('session');
	const h = useHistory();

	useEffect(() => {
		try {
			if (session) {
				(async () => {
					const { token, puid, option, srv } = session;
					const action = 'replay';
					const value = option;
					const base = srv === 'A' ? process.env.REACT_APP_API_A : process.env.REACT_APP_API_B;
					await axios.post(`${base}/${puid}/act`, { action, value }, { headers: { Authorization: `Bearer ${token}` } });
				})();
			}
		} catch (error) {
			console.log('error', error);
		}
	}, [session]);

	const cancel = async (id) => {
		try {
			if (session) {
				const { token, puid, srv } = session;
				const action = 'finish';
				const base = srv === 'A' ? process.env.REACT_APP_API_A : process.env.REACT_APP_API_B;
				await axios.post(`${base}/${puid}/act`, { action }, { headers: { Authorization: `Bearer ${token}` } });
				h.push('/');
				setSession('');
			}
		} catch (error) {
			console.log('error', error);
		}
	};

	const start = async () => {
		try {
			if (session) {
				const { token, puid, option, srv } = session;
				const action = 'rec';
				const value = option;
				const base = srv === 'A' ? process.env.REACT_APP_API_A : process.env.REACT_APP_API_B;
				await axios.post(`${base}/${puid}/act`, { action, value }, { headers: { Authorization: `Bearer ${token}` } });
				h.push('/H');
			}
		} catch (error) {
			console.log('error', error);
		}
	};
	return (
		<IonPage>
			<IonContent fullscreen scrollY={true}>
				<div className='w-full min-h-full h-auto justify-items-center items-center flex flex-col bg-c-purple'>
					<img src='/assets/media/tela-5-mobile-1.png' className='mt-12 w-[60vw]' />
					<motion.img src='/assets/media/bt-start.png' className='mt-20' onTap={start} />
					<motion.img src='/assets/media/bt-cancel.png' className='mt-8' onTap={cancel} />
				</div>
			</IonContent>
		</IonPage>
	);
}
